import React from "react";

/** prompt-kit style typing loader: three pulsing dots. */
const Loader = ({ label = "Thinking" }) => (
  <div className="flex items-center gap-2 text-sm text-gray-500">
    <span className="flex items-center gap-1">
      <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-gray-400 [animation-delay:-0.3s]" />
      <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-gray-400 [animation-delay:-0.15s]" />
      <span className="h-1.5 w-1.5 animate-bounce rounded-full bg-gray-400" />
    </span>
    <span className="animate-pulse">{label}</span>
  </div>
);

export default Loader;
